import APIError from '../errors/APIError';

import { IRestrictedArea } from '../models/RestrictedAreas';

import HttpClient from './utils/HttpClient';

type ShowParameterResponse = IRestrictedArea[];

class RestrictedAreasService {
  private httpClient = HttpClient;

  public async listRestrictedAreas(
    companyId: number,
  ): Promise<ShowParameterResponse> {
    try {
      const response = await this.httpClient.get(
        `companies/${companyId}/restrictedAreas`,
      );

      return response.data;
    } catch (error) {
      let errorMessage = '';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      throw new APIError(errorMessage);
    }
  }

  public async createRestrictedArea(
    companyId: number,
    data: any,
  ): Promise<IRestrictedArea> {
    try {
      const response = await this.httpClient.post(
        `companies/${companyId}/restrictedAreas`,
        data,
      );

      return response.data;
    } catch (error) {
      let errorMessage = '';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      throw new APIError(errorMessage);
    }
  }

  public async deleteRestrictedArea(
    companyId: number,
    restrictedAreaId: number,
  ): Promise<void> {
    try {
      await this.httpClient.delete(
        `companies/${companyId}/restrictedAreas/${restrictedAreaId}`,
      );
    } catch (error) {
      let errorMessage = '';

      if (error instanceof Error) {
        errorMessage = error.message;
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new RestrictedAreasService();
